import { useQuery, UseQueryOptions } from 'react-query';

import { CompanyContact } from '../../models';
import { useApi } from '../../context';
import { AxiosUtils } from '../../utils';
import { CerebroApiEndpoints } from '../../utils/api';
import { QueryKeys } from '.';

export function useCompanyContactsQuery(
	guid: string | undefined,
	options?: Omit<UseQueryOptions<CompanyContact[], unknown, CompanyContact[]>, 'queryKey' | 'queryFn'> | undefined
) {
	const api = useApi();

	return useQuery(
		QueryKeys.CompanyContacts(guid),
		() => AxiosUtils.getResponseData<CompanyContact[]>(api.get(CerebroApiEndpoints.CompanyContacts.Root(guid))),
		options
	);
}
